import React from 'react'

function Footer() {
    return (
        
        <div>
<h5 style={{textAlign:'center'}}>Copyright © RESTAURANTS</h5>
        </div>
    )
}

export default Footer
